import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  CUSTOM_SHADOW_MAX_ANGLE,
  CUSTOM_SHADOW_MIN_ANGLE,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-custom-shadow-angle-option/base-item-custom-shadow-angle-option.types';

interface BaseItemCustomShadowAngleOptionProps {
  dropShadowAngle: number;
  className?: string;
  onUpdateAngle(dropShadowAngle: number, undoable?: boolean): void;
}

export function BaseItemCustomShadowAngleOption({className = '', ...props}: BaseItemCustomShadowAngleOptionProps): ReactElement<any> | null {
  const onChangeAngle = (updatedAngle: number): void => {
    props.onUpdateAngle(updatedAngle, false);
  };

  const onChangeAngleEnded = (updatedAngle: number): void => {
    props.onUpdateAngle(updatedAngle);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-shadow-angle"
      className={className}
      value={props.dropShadowAngle}
      label={window.i18next.t('pmwjs_angle')}
      range={{
        min: CUSTOM_SHADOW_MIN_ANGLE,
        max: CUSTOM_SHADOW_MAX_ANGLE,
      }}
      transformDisplay={{
        min: CUSTOM_SHADOW_MIN_ANGLE,
        max: CUSTOM_SHADOW_MAX_ANGLE,
      }}
      onChange={onChangeAngle}
      onChangeEnded={onChangeAngleEnded}
    />
  );
}
